// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StoreIcon_wrapper__POPZY","circle":"StoreIcon_circle__CQLJx","slide-in-out":"StoreIcon_slide-in-out___c2Ub","fade-in-out":"StoreIcon_fade-in-out__Zd4d8"};